import styled from "styled-components";
import { rem } from "../../helpers/rem/px-to-rem";

export const BannerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${rem(8)};
  margin: ${rem(12)} ${rem(20)} 0;
  .label {
    font-size: 14px;
    padding: ${rem(4)} ${rem(10)};
    white-space: normal;
  }
  .spin {
    margin-left: ${rem(8)};
  }
  .notice {
    width: 100%;
  }
  .map-note {
    width: 100%;
    font-size: 12px;
    color: #727272;
  }
`;
